export default {
  setCategory (state, payload) {
    state.category = payload
  },
  setCheckout (state, payload) {
    state.checkout = payload
  },
  setProject (state, payload) {
    state.project = payload
  },
  setRelease (state, payload) {
    state.release = payload
  },
  setOngoing (state, payload) {
    state.going = payload
  },
  setClosed (state, payload) {
    state.closed = payload
  },
  setProjectManagement (state, payload) {
    state.projectManagement = payload
  },
  clearSelect (state, payload) {
    Object.keys(state).forEach(key => {
      state[key] = {}
    })
  },
}
